import React from "react";
import { checkTaxResidence } from "../../Utils/LogicUtilities";

// Employment Details Section
export const EmploymentDetailsSection = ({
  applicant,
  showEmploymentDetails,
  setShowEmploymentDetails,
  handleEmploymentEditClick,
  formatPhoneNumber,
  employmentAndIncomeReducer,
  occupationCodes,
}) => {
  return (
    <div className="mb-4">
      <div
        className="d-flex align-items-center mb-3"
        style={{ cursor: "pointer" }}
        onClick={() => setShowEmploymentDetails(!showEmploymentDetails)}
      >
        <span
          style={{
            color: "#e91e63",
            fontSize: "14px",
            fontWeight: "600",
            marginRight: "8px",
          }}
        >
          Employment
        </span>
        <i
          className={`fas fa-chevron-${
            showEmploymentDetails ? "down" : "right"
          }`}
          style={{ color: "#e91e63", fontSize: "12px" }}
        ></i>
      </div>

      {showEmploymentDetails && (
        <div className="[ details-section ] [ mb-3 ]">
          <div className="[ row ] [ details-section__header">
            <div className="[ col-12 ]">
              <h3 className="[ d-flex justify-content-between align-items-center ]">
                EMPLOYMENT DETAILS
                <button
                  type="button"
                  className="[ btn edit-btn ]"
                  aria-label="edit"
                  onClick={handleEmploymentEditClick}
                >
                  <span className="[ edit-icon ]"></span>
                  <span className="[ edit-btn__label ]">Edit</span>
                </button>
              </h3>
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              Employment&nbsp;status:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {employmentAndIncomeReducer.statusList.find(
                (item) => item.code === applicant?.employment?.employmentStatus
              )?.description || "—"}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              Occupation:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {occupationCodes.find(
                (item) => item.code === applicant?.employment?.occupationCode
              )?.description || "—"}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              Position:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {applicant?.employment?.employerPosition?.toLowerCase() ===
              "other"
                ? applicant?.employment?.jobTitle || "—"
                : applicant?.employment?.employerPosition || "—"}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              Employer name:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {applicant?.employment?.currentEmployer || "—"}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              Employer address:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {applicant?.employment?.employerLine1
                ? applicant?.employment?.employerLine1 +
                  " " +
                  applicant?.employment?.employerCity +
                  " " +
                  applicant?.employment?.employerProv +
                  " " +
                  applicant?.employment?.employerPc
                : "—"}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              Employer&nbsp;contact&nbsp;no.:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {applicant?.employment?.employerPhone
                ? formatPhoneNumber(
                    applicant.employment.employerPhoneArea +
                      applicant.employment.employerPhone
                  )
                : "—"}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              Monthly gross income:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {applicant?.employment?.employerSalary
                ? `$${parseFloat(applicant.employment.employerSalary).toFixed(
                    2
                  )}`
                : "—"}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              Source of income:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {employmentAndIncomeReducer.incomeSourcesList.find(
                (item) => item.code === applicant?.employment?.incomeType
              )?.description || "—"}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Taxation Details Section
export const TaxationDetailsSection = ({
  applicant,
  showTaxationDetails,
  setShowTaxationDetails,
  handleTaxationEditClick,
  maskSensitiveData,
}) => {
  // Get tax residence information using utility function
  const {
    hasUsaTaxResidence,
    hasOtherCountryTaxResidence,
    hasOtherTaxResidence,
    oecdTaxResidency,
    oecdTaxId,
  } = checkTaxResidence(applicant);

  return (
    <div className="mb-4">
      <div
        className="d-flex align-items-center mb-3"
        style={{ cursor: "pointer" }}
        onClick={() => setShowTaxationDetails(!showTaxationDetails)}
      >
        <span
          style={{
            color: "#e91e63",
            fontSize: "14px",
            fontWeight: "600",
            marginRight: "8px",
          }}
        >
          Taxation Details
        </span>
        <i
          className={`fas fa-chevron-${showTaxationDetails ? "down" : "right"}`}
          style={{ color: "#e91e63", fontSize: "12px" }}
        ></i>
      </div>

      {showTaxationDetails && (
        <div className="[ details-section ] [ mb-3 ]">
          <div className="[ row ] [ details-section__header">
            <div className="[ col-12 ]">
              <h3 className="[ d-flex justify-content-between align-items-center ]">
                TAXATION DETAILS
                <button
                  type="button"
                  className="[ btn edit-btn ]"
                  aria-label="edit"
                  onClick={handleTaxationEditClick}
                >
                  <span className="[ edit-icon ]"></span>
                  <span className="[ edit-btn__label ]">Edit</span>
                </button>
              </h3>
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-6 ] [ details-section__item-label ]">
              SIN:
            </div>
            <div className="[ col-6 ] [ details-section__item-description ]">
              {maskSensitiveData(applicant?.member?.sin)}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-6 ] [ details-section__item-label ]">
              Other&nbsp;tax&nbsp;residence&nbsp;(TIN)&nbsp;:&nbsp;
            </div>
            <div className="[ col-6 ] [ details-section__item-description ]">
              {hasOtherTaxResidence ? "Yes" : "No"}
            </div>
          </div>
          {hasUsaTaxResidence && (
            <div className="[ row ] [ details-section__item ]">
              <div className="[ col-6 ] [ details-section__item-label ]">
                USA:
              </div>
              <div className="[ col-6 ] [ details-section__item-description ]">
                {applicant?.regulatory?.ssn || "—"}
              </div>
            </div>
          )}
          {hasOtherCountryTaxResidence && (
            <>
              <div className="[ row ] [ details-section__item ]">
                <div className="[ col-6 ] [ details-section__item-label ]">
                  {oecdTaxResidency?.Value || "Other Country"}:
                </div>
                <div className="[ col-6 ] [ details-section__item-description ]">
                  {oecdTaxId?.Value || "—"}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

// Compliance Details Section
export const ComplianceDetailsSection = ({
  applicant,
  showComplianceDetails,
  setShowComplianceDetails,
  handleComplianceEditClick,
  complianceReducer,
}) => {
  return (
    <div className="mb-4">
      <div
        className="d-flex align-items-center mb-3"
        style={{ cursor: "pointer" }}
        onClick={() => setShowComplianceDetails(!showComplianceDetails)}
      >
        <span
          style={{
            color: "#e91e63",
            fontSize: "14px",
            fontWeight: "600",
            marginRight: "8px",
          }}
        >
          Compliance
        </span>
        <i
          className={`fas fa-chevron-${
            showComplianceDetails ? "down" : "right"
          }`}
          style={{ color: "#e91e63", fontSize: "12px" }}
        ></i>
      </div>

      {showComplianceDetails && (
        <div className="[ details-section ] [ mb-3 ]">
          <div className="[ row ] [ details-section__header">
            <div className="[ col-12 ]">
              <h3 className="[ d-flex justify-content-between align-items-center ]">
                COMPLIANCE DETAILS
                <button
                  type="button"
                  className="[ btn edit-btn ]"
                  aria-label="edit"
                  onClick={handleComplianceEditClick}
                >
                  <span className="[ edit-icon ]"></span>
                  <span className="[ edit-btn__label ]">Edit</span>
                </button>
              </h3>
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              PEP / HIO:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {(applicant?.peps && applicant.peps.length > 0) ||
              applicant?.regulatory?.memberIsPedp ||
              applicant?.regulatory?.memberIsPefp ||
              applicant?.regulatory?.memberIsHio
                ? "Yes"
                : "No"}
            </div>
          </div>
          {applicant?.peps && applicant.peps.length > 0 && (
            <>
              {applicant.peps.map((pep, index) => (
                <div className="[ row ] [ details-section__item ]">
                  <div
                    className="[ col-5 ] [ details-section__item-label ]"
                    style={{ paddingLeft: "30px" }}
                  >
                    Who:
                  </div>
                  <div className="[ col-7 ] [ details-section__item-description ]">
                    {pep.name || "—"}
                  </div>
                  <div
                    className="[ col-5 ] [ details-section__item-label ]"
                    style={{ paddingLeft: "30px" }}
                  >
                    Jurisdiction:
                  </div>
                  <div className="[ col-7 ] [ details-section__item-description ]">
                    {pep.jurisdiction || "—"}
                  </div>
                  <div
                    className="[ col-5 ] [ details-section__item-label ]"
                    style={{ paddingLeft: "30px" }}
                  >
                    Source of funds:
                  </div>
                  <div className="[ col-7 ] [ details-section__item-description ]">
                    {pep.fundsSource || "—"}
                  </div>
                </div>
              ))}
            </>
          )}
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              Banking relationship:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {complianceReducer.accountPurposeList.find(
                (item) =>
                  item.code === applicant?.member?.intendedUseOfMembership
              )?.description || "—"}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              Third party:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {applicant?.thirdParties && applicant.thirdParties.length > 0
                ? "Yes"
                : "No"}
            </div>
          </div>
          {applicant?.thirdParties && applicant.thirdParties.length > 0 && (
            <>
              {applicant.thirdParties.map((party, index) => (
                <React.Fragment key={index}>
                  <div
                    className="[ row ] [ details-section__item ]"
                    style={{ paddingLeft: "20px" }}
                  >
                    <div className="[ col-5 ] [ details-section__item-label ]">
                      Name:
                    </div>
                    <div className="[ col-7 ] [ details-section__item-description ]">
                      {party.name || "—"}
                    </div>
                  </div>
                  <div
                    className="[ row ] [ details-section__item ]"
                    style={{ paddingLeft: "20px" }}
                  >
                    <div className="[ col-5 ] [ details-section__item-label ]">
                      Relationship:
                    </div>
                    <div className="[ col-7 ] [ details-section__item-description ]">
                      {party.relationship || "—"}
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
};
